// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2wZFA","text":"SelectPayment_text__1FR1x","title":"SelectPayment_title__1MPzU","btn":"SelectPayment_btn__2Jp5X"};